import React, { Component } from 'react'
import './public-object-album.css'

import AlbumHeader from '../../components/album-common/albumHeader'
import AlbumContent from '../../components/album-common/albumContent'
import AlbumFooter from '../../components/album-common/albumFooter'

export default class PublicObjectAlbum extends Component {
    render() {
        return (
            < >
                <AlbumHeader />
                <AlbumContent />
                <AlbumFooter />
            </>
        )
    }
}